import { fromJS } from 'immutable';
import createAction from '../../../../utils/redux-helpers/createAction';

const handler = (state, { data }) =>
  state.setIn(['tables', 'drivers'], fromJS(data));

export const setDrivers = createAction({
  action: ['setDrivers', 'data'],
  handler,
});
